import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/views/home'),
      hidden: true,
      redirect: '/index'
    },
    {
      path: '/demo',
      component: () => import('@/components/cropper/demo'),
      hidden: true
    },
    {
      path: '/home',
      name: 'index',
      component: () => import('@/views/home'),
      children: [// 这里就是二级路由的配置
        {
          path: '/index',
          name: 'Index',
          component: () => import('@/views/index')
        },
        {
          path: '/login',
          name: 'Login',
          component: () => import('@/views/login')
        },
        {
          path: '/course',
          name: 'Course',
          component: () => import('@/views/course')
        },
        {
          path: '/teacher',
          name: 'Teacher',
          component: () => import('@/views/teacher')
        },
        {
          path: '/activity',
          name: 'Activity',
          component: () => import('@/views/activity')
        },
        {
          path: '/activity-detail',
          name: 'ActivityDetail',
          component: () => import('@/views/activityDetail')
        },
        {
          path: '/about',
          name: 'About',
          component: () => import('@/views/about')
        },
        {
          path: '/download',
          name: 'Download',
          component: () => import('@/views/download')
        }
      ]
    },
    {
      path: '/teacher-login',
      name: 'TeacherLogin',
      component: () => import('@/views/teacher/login')
    },
    {
      path: '/teacher-center',
      name: 'TeacherCenter',
      component: () => import('@/views/teacher/center'),
      redirect: '/teacher-home',
      children: [// 这里就是二级路由的配置
        {
          path: '/teacher-setting',
          name: 'TeacherSetting',
          component: () => import('@/views/teacher/teacherSetting'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-setpwd',
          name: 'TeacherUpdatepwd',
          component: () => import('@/views/teacher/updatepwd'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-leave',
          name: 'TeacherLeave',
          component: () => import('@/views/teacher/studentLeave'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-info',
          name: 'TeacherInfo',
          component: () => import('@/views/teacher/teacherInfo'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-total',
          name: 'ClassTotal',
          component: () => import('@/views/teacher/amountTotal'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-course',
          name: 'TeacherCourse',
          component: () => import('@/views/teacher/calendar'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/class-call',
          name: 'ClassCall',
          component: () => import('@/views/teacher/classCall'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/call-student',
          name: 'ClassCallStudent',
          component: () => import('@/views/teacher/classCallStudent'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-work',
          name: 'ClassWorkList',
          component: () => import('@/views/teacher/classWork'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-work-detail',
          name: 'ClassWorkDetail',
          component: () => import('@/views/teacher/components/classWork/WorkDetail'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-rules',
          name: 'TeacherRules',
          component: () => import('@/views/teacher/rulesList'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/problem-feedback',
          name: 'ProblemFeedback',
          component: () => import('@/views/teacher/problemFeedback'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/problem-feedback-detail',
          name: 'ProblemFeedbackDetail',
          component: () => import('@/views/teacher/ProblemFeedbackDetail'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/tm-feedback',
          name: 'TMFeedback',
          component: () => import('@/views/teacher/TMFeedback'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-rules-detail',
          name: 'TeacherRulesDetail',
          component: () => import('@/views/teacher/rulesDetail'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-contract',
          name: 'TeacherContract',
          component: () => import('@/views/teacher/TeacherContract'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-home',
          name: 'TeacherHome',
          component: () => import('@/views/teacher/teacherHome'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/review-display',
          name: 'ReviewDisplay',
          component: () => import('@/views/teacher/ReviewDisplay'),
          meta: {
            teacherAuth: true
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js